<template functional>
<div 
  style="border:1px solid #ddd;border-radius:10px;padding:5px 10px;background: #fff;"
>
  <v-layout row wrap>
    <v-flex xs12>
      <v-flex v-if="label!==''" xs12 class="formElementLabel">{{props.label}}</v-flex>
      <v-layout row wrap>
        <v-flex xs3 style="margin: 1px 0;">
          <v-avatar tile size="80">
            <v-img v-lazy:background-image="props.rank.imageurl" class="foodImg" :alt="name"/>
          </v-avatar>
        </v-flex>
        <v-flex xs9>
          <p style="height:45px;text-align:left;padding-top:0px;padding-left:8px;margin-bottom:0px;font-weight:bold;font-size:11pt;">
            {{props.rank.name}}
          </p>
          <p style="margin-bottom:0;">
            <v-btn
              :to="{name: 'searchFoodDetail', params: {id: props.rank.id}}"
              flat small outline color="primary"
            >
              食品ページ
            </v-btn>
            <v-btn
              :to="{name: 'searchReviewDetail', params: {id: props.rank.postId}}"
              small dark color="primary" v-if="props.rank.postId"
            >
              <v-icon small>chat_bubble</v-icon>
              カラログ
            </v-btn>
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import getImageUrl from '@/assets/js/getImageUrl.js'

export default {
  name: 'FoodCardMin',
  props: {
    rank: Object,
    label: String,
    mode: {
      type: String,
      default: 'normal'
    }
  },
  components: {
  }
}
</script>

<style scoped>
.formElementLabel {
  text-align: left;
  color:#888;
}
.foodImg[lazy='loaded'] {
  background-size: cover;
}
</style>